import {
	GroupedTimetableByVehicleWithStopConnection,
	TimetableWithNestedAntennas,
} from '@/new-transport/_models/transport-timetable.model';

/**
 * Recursively gets timetables with nested antennas for each timetable in the array.
 *
 * @param {GroupedTimetableByVehicleWithStopConnection[]} arr - Array of grouped timetables by vehicle with stop connections.
 * @param {GroupedTimetableByVehicleWithStopConnection[]} groupedVehicles - Array of all grouped vehicles to find antennas from.
 * @returns {TimetableWithNestedAntennas[]} Array of timetables with nested antennas.
 */
export const getTimetablesWithNestedAntennas = (
	arr: GroupedTimetableByVehicleWithStopConnection[],
	groupedVehicles: GroupedTimetableByVehicleWithStopConnection[],
): TimetableWithNestedAntennas[] =>
	arr.map((timetable) => ({
		...timetable,
		antennasForVehicle: getTimetablesWithNestedAntennas(
			findAntennasForTimetable(timetable, groupedVehicles),
			groupedVehicles,
		),
		editableVehicle: false,
	}));

/**
 * Finds antennas (sub-vehicles) for a given timetable.
 *
 * @param {GroupedTimetableByVehicleWithStopConnection} timetable - The timetable for which antennas need to be found.
 * @param {GroupedTimetableByVehicleWithStopConnection[]} groupedVehicles - Array of all grouped vehicles to search in.
 * @returns {GroupedTimetableByVehicleWithStopConnection[]} Array of antennas related to the given timetable.
 */
export const findAntennasForTimetable = (
	timetable: GroupedTimetableByVehicleWithStopConnection,
	groupedVehicles: GroupedTimetableByVehicleWithStopConnection[],
): GroupedTimetableByVehicleWithStopConnection[] =>
	groupedVehicles.filter(({ vehicle }) =>
		timetable.antennasForVehicle.some(({ vehicle: antennaVehicle }) => antennaVehicle === vehicle.id),
	);
